import * as React from 'react';

import * as styles from './ListingCompilationLayout.css';

export const ListingCompilationLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
